
import { OrderItem } from '../types';

// Função robusta que aceita números ou strings e evita crashes
export const formatCurrency = (value: any) => {
  const num = typeof value === 'number' ? value : parseFloat(value);
  if (isNaN(num)) return 'R$ 0,00';
  
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(num);
};

export const generateOrderId = () => Math.random().toString(36).substr(2, 9);

export const normalizeMoney = (value: any) => {
  const num = typeof value === 'number' ? value : parseFloat(String(value || '').replace(',', '.'));
  return Number.isFinite(num) ? Math.max(0, num) : 0;
};

export const getItemDiscount = (item: OrderItem) => Math.min(normalizeMoney(item.discount), normalizeMoney(item.price));

export const getItemUnitPrice = (item: OrderItem) => Math.max(0, normalizeMoney(item.price) - getItemDiscount(item));

export const calculateOrderItemTotal = (item: OrderItem) => getItemUnitPrice(item) * Number(item.quantity || 0);

export const calculateTableTotal = (items: OrderItem[]) => {
  return items.reduce((acc, item) => acc + calculateOrderItemTotal(item), 0);
};
